import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

export type LandingEnvironment = typeof environment;

export const EnvironmentToken = new InjectionToken<LandingEnvironment>('lp.environment');
